import { AzureBlobFSStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/azure-blob-fs-read-settings';
import { Metamodel, OneLakeFileLinkedService } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.oneLakeFile.storeRead,
    display: [],
    tags: { linkedServiceModel: Metamodel.modelFor(OneLakeFileLinkedService) }
})
export class OneLakeFilesReadSettings extends AzureBlobFSStoreReadSettings {}
